@if (clientId) {
  <article class="client-cvs-tab" [class.is-workspace]="isWorkspace">

    @if (auth.isAdmin) {
      <div class="cv-generate-card">
        @if (isWorkspace) {
          <div class="cv-workspace-title">{{ 'cv.workspace.title' | translate }}</div>
        }
        <div class="cv-generate-right">
          <div class="cv-generate-main">
            <div class="cv-generate-field">
              <label class="cv-generate-label">{{ 'cv.workspace.consultant' | translate }}</label>
              <bst-list-adder
                class="cvs-tab-user-picker"
                size="small"
                status="basic"
                [placeholder]="'cv.client.pickUser' | translate"
                [listTemplate]="userlisttemplate"
                [autolist]="true"
                [formControl]="userControl"
                [single]="true"
                [filters]="{logo: true}"
                [target]="'member'">
              </bst-list-adder>
            </div>
            <button nbButton
              size="small"
              status="primary"
              shape="semi-round"
              [disabled]="!selectedUserId"
              (click)="openGenerateDialog()">
              <nb-icon icon="plus-outline"></nb-icon>
              {{ 'cv.hub.open' | translate }}
            </button>
          </div>
          <div class="cv-generate-tools">
            @if (canManageTheme) {
              <button nbButton
                size="small"
                ghost
                status="basic"
                shape="semi-round"
                [routerLink]="studioLink">
                <nb-icon icon="layout-outline"></nb-icon>
                {{ 'nav_studio' | translate }}
              </button>
            }
            @if (docView === 'standard') {
              <button nbButton size="small" ghost status="basic" (click)="cvList?.openOptions()" [nbTooltip]="'options' | translate" [attr.aria-label]="'options' | translate">
                <nb-icon icon="more-vertical-outline"></nb-icon>
              </button>
            }
          </div>
        </div>
      </div>
    } @else if (isWorkspace) {
      <header class="cv-workspace-head">
        <h1>{{ 'cv.workspace.title' | translate }}</h1>
        <p>{{ 'cv.workspace.subtitle' | translate }}</p>
      </header>
    }

    <div class="cvs-tab-view-switch">
      <div class="seg-switch" role="radiogroup">
        @if (auth.isAdmin) {
          <button type="button" role="radio" class="seg-item"
                  [class.is-active]="docView === 'standard'"
                  [attr.aria-checked]="docView === 'standard'"
                  (click)="docView = 'standard'">
            {{ 'cv.docs.viewStandard' | translate }}
          </button>
        }
        <button type="button" role="radio" class="seg-item"
                [class.is-active]="docView === 'tailored'"
                [attr.aria-checked]="docView === 'tailored'"
                (click)="docView = 'tailored'">
          {{ 'cv.docs.viewTailored' | translate }}
        </button>
      </div>
    </div>

    @if (docView === 'standard') {
      <bst-cv-list #cvList [scope]="'client'" [scopeId]="clientId" [subjectUserId]="selectedUserId"></bst-cv-list>
    } @else {
      <bst-tailored-cv-list [subjectUserId]="selectedUserId" [clientId]="clientId"></bst-tailored-cv-list>
    }
  </article>
}

<ng-template #userlisttemplate let-result="result">
  <nb-user color="#eee" [name]="result.name" [picture]="userLogo(result)" size="small"></nb-user>
</ng-template>
